import Vue from 'vue'
import Router from 'vue-router'
import OktaVue, { LoginCallback } from '@okta/okta-vue'
import { OktaAuth } from '@okta/okta-auth-js'

const oktaAuth = new OktaAuth({
  issuer: 'https://nike.okta.com/oauth2/aus27z7p76as9Dz0H1t7',
  clientId: 'nike.nddcops.amt',
  redirectUri: window.location.origin + '/oktaCallback',
  scopes: ['openid', 'profile', 'email','offline_access']
})

Vue.use(Router)
Vue.use(OktaVue, { oktaAuth })

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: () => import('../views/Sys/Login.vue')
    },
    {
      path: '/*id_token*',
      name: 'Login',
      component: () => import('../views/Sys/Login.vue')
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('../views/Sys/Login.vue')
    },
    {
      path: '/oktaCallback',
      component: () => import('@/views/loginCallback/index'),
      hidden: true
    },
    {
      path: '/oktalogin',
      component: () => import('@/views/oktalogin/index'),
      hidden: true
    },
    {
      path: '/oktalogout',
      component: () => import('@/views/oktalogin/index'),
      hidden: true
    },
    {
      path: '/logout',
      name: 'Login',
      component: () => import('../views/Sys/Login.vue')
    },
    {
      path: '/resetPassword',
      name: 'resetPassword',
      component: () => import('../views/Sys/ResetPassword.vue')
    },
    // {
    //   path: '/',
    //   name: 'Login',
    //   component: () => import('../views/Login2.vue')
    // },
    // {
    //   path: '/*id_token*',
    //   name: 'Login',
    //   component: () => import('../views/Login2.vue')
    // },
    // {
    //   path: '/login',
    //   name: 'Login',
    //   component: () => import('../views/Login2.vue')
    // },
    // {
    //   path: '/logout',
    //   name: 'Login',
    //   component: () => import('../views/Logout.vue')
    // },
    {
      path: '/localLogin',
      name: 'LocalLogin',
      component: () => import('../views/Sys/Login.vue')
    },

    {
      path: '/imageEditor',
      name: 'ImageEditor',
      component: () => import('../components/ImageEditor.vue')
    },
    {
      path: '/imageView/',
      name: 'ImageView',
      component: () => import('../components/ImageView.vue')
    },
    {
      path: '/container',
      name: 'Container',
      component: () => import("../components/Container.vue"),
      children: [
        {
          path: '/imageTaskList',
          name: 'ImageTaskList',
          component: () => import('../views/Image/ImageTaskList.vue')
        },
        {
          path: '/imageTaskDetail',
          name: 'ImageTaskDetail',
          component: () => import("../views/Image/ImageTaskDetail.vue"),
        },
        {
          path: '/imageCompare',
          name: 'ImageCompare',
          component: () => import('../views/Image/ImageCompare.vue')
        },
        {
          path: '/errorTicket',
          name: 'errorTicket',
          component: () => import('../views/Image/errorTicket.vue')
        },
        {
          path: '/imageCompareOperation',
          name: 'ImageCompare',
          component: () => import('../views/Image/ImageOperation.vue')
        },
        {
          path: '/imageCompareHistory',
          name: 'ImageCompare',
          component: () => import('../views/MasterData/ImageHistoryOperation.vue')
        },
        {
          path: '/imageCompareHistory2',
          name: 'ProductManage',
          component: () => import('../views/MasterData/ImageHistoryOperation2.vue')
        },
        {
          path: '/imageOldCompareHistory',
          name: 'ProductManage',
          component: () => import('../views/MasterData/ImageOldHistoryOperation.vue')
        },
        {
          path: '/imageOperation',
          name: 'ImageOperation',
          component: () => import('../views/Image/ImageOperation.vue')
        },
        {
          path: '/imageTrackingList',
          name: 'ImageTrackingList',
          component: () => import("../views/Image/ImageTrackingList.vue"),
        },
        {
          path: '/sampleUpload',
          name: 'SampleUpload',
          component: () => import("../views/MasterData/SampleUpload.vue"),
        },
        {
          path: '/imageDistribute',
          name: 'ImageDistribute',
          component: () => import("../views/Image/ImageDistribute.vue"),
        },
        {
          path: '/copyTrackingList',
          name: 'CopyTrackingList',
          component: () => import("../views/Copy/CopyTrackingList.vue"),
        },
        {
          path: '/copyAirbag',
          name: 'CopyAirbag',
          component: () => import("../views/Copy/CopyAirbag.vue"),
        },
        {
          path: '/copyDistribute',
          name: 'CopyDistribute',
          component: () => import("../views/Copy/CopyDistribute.vue"),
        },
        {
          path: '/copyDistributeHk',
          name: 'CopyDistributeHk',
          component: () => import("../views/Copy/CopyDistributeHk.vue"),
        },
        {
          path: '/sysUser',
          name: 'SysUser',
          component: () => import("../views/Sys/SysUser.vue"),
        },
        {
          path: '/sysMail',
          name: 'SysMail',
          component: () => import("../views/Sys/SysMail.vue"),
        },
        {
          path: '/sysApiInfo',
          name: 'sysApiInfo',
          component: () => import("../views/Sys/sysApiInfo.vue"),
        },
        {
          path: '/sysOrg',
          name: 'SysOrg',
          component: () => import("../views/Sys/SysOrganization.vue"),
        },
        {
          path: '/sysRole',
          name: 'SysRole',
          component: () => import("../views/Sys/SysRole.vue"),
        },
        {
          path: '/sysApiRole',
          name: 'SysApiRole',
          component: () => import("../views/Sys/SysApiRole.vue"),
        },
        {
          path: '/copyQc',
          name: 'CopyQc',
          component: () => import("../views/Copy/CopyQc.vue"),
        },
        {
          path: '/copyQcHkList',
          name: 'CopyQcHkList',
          component: () => import("../views/Copy/CopyQcHkList.vue"),
        },
        {
          path: '/copyQcOp',
          name: 'CopyQcOp',
          component: () => import("../views/Copy/CopyQcOp.vue"),
        },
        {
          path: '/copyQcHk',
          name: 'CopyQcHk',
          component: () => import("../views/Copy/CopyQcHk.vue"),
        },
        {
          path: '/imageQc',
          name: 'ImageQc',
          component: () => import("../views/Image/ImageQc.vue"),
        },
        {
          path: '/imageQcOperation',
          name: 'ImageQc',
          component: () => import("../views/Image/ImageQcOperation.vue"),
        },
        {
          path: '/copyTaskList',
          name: 'CopyTaskList',
          component: () => import("../views/Copy/CopyTaskList.vue"),
        },
        {
          path: '/copyTaskDetail',
          name: 'CopyTaskDetail',
          component: () => import("../views/Copy/CopyTaskDetail.vue"),
        },
        {
          path: '/copyTaskListHk',
          name: 'CopyTaskListHk',
          component: () => import("../views/Copy/CopyTaskListHk.vue"),
        },
        {
          path: '/copyTaskDetailHk',
          name: 'CopyTaskDetailHk',
          component: () => import("../views/Copy/CopyTaskDetailHk.vue"),
        },
        {
          path: '/dictForbidden',
          name: 'DictForbidden',
          component: () => import("../views/Sys/DictForbidden.vue"),
        },
        {
          path: '/dictProfessional',
          name: 'DictProfessional',
          component: () => import("../views/Sys/DictProfessional.vue"),
        },
        {
          path: '/dictCopyErrorType',
          name: 'DictCopyErrorType',
          component: () => import("../views/Sys/DictCopyErrorType.vue"),
        },
        {
          path: '/dictImageErrorType',
          name: 'DictImageErrorType',
          component: () => import("../views/Sys/DictImageErrorType.vue"),
        },
        {
          path: '/uploadEnCopy',
          name: 'UploadEnCopy',
          component: () => import("../views/Copy/UploadEnCopy.vue"),
        },
        {
          path: '/uploadTranslate',
          name: 'UploadTranslate',
          component: () => import("../views/Copy/UploadTranslate.vue"),
        },
        {
          path: '/sampleDistribute',
          name: 'SampleDistribute',
          component: () => import("../views/MasterData/SampleDistribute.vue"),
        },
        {
          path: '/copyTranslate',
          name: 'CopyTranslate',
          component: () => import("../views/Copy/CopyTranslate.vue"),
        },
        {
          path: '/copyTranslateHkList',
          name: 'CopyTranslateHkList',
          component: () => import("../views/Copy/CopyTranslateHkList.vue"),
        },
        {
          path: '/copyTranslateOp',
          name: 'CopyTranslateOp',
          component: () => import("../views/Copy/CopyTranslateOp.vue")
        },
        {
          path: '/copyTranslateHK',
          name: 'CopyTranslateHK',
          component: () => import("../views/Copy/CopyTranslateHk.vue")
        },
        {
          path: '/copyTaskHistory/:id/:code/:platformType/:isOld',
          name: 'copyTaskHistory',
          component: () => import("../views/Copy/CopyTaskHistory.vue"),
        },
        {
          path: '/copyHkTaskHistory/:id/:code/:platformType/:isOld',
          name: 'CopyHkTaskHistory',
          component: () => import("../views/Copy/CopyHkTaskHistory.vue"),
        },
        {
          path: '/copyTaskHistory1/:id/:code/:platformType/:isOld/:isRelease/:gmtCreate/:reviewDate/:releaseTime',
          name: 'copyTaskHistory1',
          component: () => import("../views/Copy/CopyTaskHistory1.vue"),
        },
        {
          path: '/copyHkTaskHistory1/:id/:code/:platformType/:isOld/:isRelease/:gmtCreate/:reviewDate/:releaseTime',
          name: 'CopyHkTaskHistory1',
          component: () => import("../views/Copy/CopyHkTaskHistory1.vue"),
        },
        {
          path: '/copyReturn',
          name: 'CopyReturn',
          component: () => import("../views/Copy/CopyReturn.vue"),
        },
        {
          path: '/copyCombineList',
          name: 'CopyCombineList',
          component: () => import("../views/Copy/CopyCombineList.vue"),
        },
        {
          path: '/copyCombineOp',
          name: 'CopyCombineOp',
          component: () => import("../views/Copy/CopyCombineOp.vue"),
        },
        {
          path: '/productManage',
          name: 'ProductManage',
          component: () => import("../views/MasterData/ImageManage.vue"),
        },
        {
          path: '/readiness',
          name: 'Readiness',
          component: () => import("../views/Report/Readiness.vue"),
        },
        {
          path: '/copyReadiness',
          name: 'CopyReadiness',
          component: () => import("../views/Report/CopyReadiness.vue"),
        },
        {
          path: '/leadTime',
          name: 'LeadTime',
          component: () => import("../views/Report/LeadTime.vue"),
        },
        {
          path: '/copyManage',
          name: 'CopyManage',
          component: () => import("../views/MasterData/CopyManage1.vue"),
        },
        {
          path: '/CNCopyDetail',
          name: 'CNCopyDetail',
          component: () => import("../views/MasterData/CNCopyDetail.vue"),
        },
        {
          path: '/HKCopyDetail',
          name: 'HKCopyDetail',
          component: () => import("../views/MasterData/HKCopyDetail.vue"),
        },
        {
          path: '/imageErrorLogList',
          name: 'ImageErrorLogList',
          component: () => import("../views/Report/ImageErrorLogList.vue"),
        },
        {
          path: '/sysReport',
          name: 'SysReport',
          component: () => import("../views/Report/SysReport.vue"),
        },
        {
          path: '/updateImageTL',
          name: 'ManualImageTrackingList',
          component: () => import("../views/Report/ManualImageTrackingList.vue"),
        },
        {
          path: '/updateCopyTL',
          name: 'ManualCopyTrackingList',
          component: () => import("../views/Report/ManualCopyTrackingList.vue"),
        },
        {
          path: '/sftpUpload',
          name: 'SftpUpload',
          component: () => import("../views/MasterData/SftpUpload.vue"),
        },
        {
          path: '/copyDownload',
          name: 'CopyDownload',
          component: () => import("../views/downloadZip/CopyDownload.vue"),
        },
        {
          path: '/imageDownload',
          name: 'ImageDownload',
          component: () => import("../views/downloadZip/ImageDownload.vue"),
        },
        {
          path: '/sizeChart',
          name: 'SizeChart',
          component: () => import("../views/MasterData/sizeChart/SizeChart.vue"),
        },
        {
          path: '/sizeChartDetail',
          name: 'sizeChartDetail',
          component: () => import("../views/MasterData/sizeChart/SizeChartDetail.vue"),
        },
        {
          path: '/sizeChart/review',
          name: 'Review',
          component: () => import("../views/MasterData/sizeChart/Review.vue"),
        },

        {
          path: '/attribution',
          name: 'attribution',
          component: () => import("../views/MasterData/SkuAndAttribution.vue"),
        },
        {
          path: '/fitReport',
          name: 'fitReport',
          component: () => import("../views/MasterData/FitReportFile.vue"),
        },
        {
          path: '/fitReportDetail',
          name: 'fitReportDetail',
          component: () => import("../views/MasterData/FitReportDetail.vue"),
        },
        {
          path: '/dataImport',
          name: 'dataImport',
          component: () => import("../views/localImage/DataImport.vue"),
        },
        {
          path: '/assetReview',
          name: 'assetReview',
          component: () => import("../views/localImage/AssetReview"),
        },
        {
          path: '/localImageCompare',
          name: 'localImageCompare',
          component: () => import("../views/localImage/ImageCompare.vue"),
        },

        {
          path: '/localImageQc',
          name: 'localImageQc',
          component: () => import("../views/localImage/ImageQC.vue"),
        },
        {
          path: '/localImageQcOperation',
          name: 'localImageQc',
          component: () => import("../views/localImage/ImageQcOperation.vue"),
        },
        {
          path: '/localImageTaskDetail',
          name: 'localImageTaskDetail',
          component: () => import("../views/localImage/LocalImageTaskDetail.vue"),
        },
        // localImageDistribute 订单管理
        {
          path: '/localImageDistribute',
          name: 'localImageDistribute',
          component: () => import("../views/localImage/OrderManagement.vue"),
        },
        // 任务管理
        {
          path: '/localImageTaskList',
          name: 'localImageTaskList',
          component: () => import("../views/localImage/LocalImageTaskList.vue"),
        },
        {
          path: '/localImageCompareOperation',
          name: 'localImageCompare',
          component: () => import('../views/localImage/ImageOperation.vue')
        },
        {
          path: '/attributeManagement',
          name: 'Attribute Management',
          component: () => import('../views/Sys/Attributes/AttributeManagement.vue')
        },
        {
          path: '/scdsTaskList',
          name: 'scdsTaskList',
          component: () => import("../views/SCDS/taskList.vue"),
        },
        {
          path: '/assetDetailList',
          name: 'assetDetailList',
          component: () => import("../views/SCDS/assetDetailList.vue"),
        },
        {
          path: '/assetConfidentialityManagement',
          name: 'assetConfidentialityManagement',
          component: () => import("../views/MasterData/assetConfidentialityManagement.vue"),
        },
        {
          path: '/downloadImageShare',
          name: 'downloadImageShare',
          component: () => import("../views/MasterData/DownloadImageShare.vue"),
        },
        {
          path: '/trackingList',
          name: 'trackingList',
          component: () => import("../views/MasterData/TrackingList"),
        },
        {
          path: '/assetsUploadList',
          name: 'assetsUploadList',
          component: () => import("../views/MasterData/AssetsUploadList"),
        },
        {
          path: '/sysDict',
          name: 'sysDict',
          component: () => import("../views/Sys/Dict/SysDict"),
        },
        {
          path: '/sysApiInfo',
          name: 'sysApiInfo',
          component: () => import("../views/Sys/sysApiInfo.vue"),
        },

        {
          path: '/sysGlossary',
          name: 'sysGlossary',
          component: () => import("../views/Sys/sysGlossary.vue"),
        },
        {
          path: '/sysDisclaimer',
          name: 'sysDisclaimer',
          component: () => import("../views/Sys/sysDisclaimer.vue"),
        },
        {
          path: '/proofRule',
          name: 'proofRule',
          component: () => import("../views/Sys/sysBiRepository.vue"),
        },
        {
          path: '/productKnowledge',
          name: 'productKnowledge',
          component: () => import("../views/Sys/productKnowledge.vue"),
        },
        {
          path: '/ruleManagement',
          name: 'ruleManagement',
          component: () => import("../views/Sys/ruleManagement.vue"),
        },
        {
          path: '/imageCertificateList',
          name: 'imageCertificateList',
          component: () => import("../views/Sys/ImageCertificateList.vue"),
        },

        {
          path: '/licenseUpload',
          name: 'licenseUpload',
          component: () => import('../views/Sys/License.vue')
        },
        {
          path: '/sellPoint',
          name: 'sellPoint',
          component: () => import("../views/MasterData/SellPointData.vue"),
        },
        {
          path: '/copyDatabase',
          name: 'copyDatabase',
          component: () => import("../views/MasterData/CopyDatabase.vue"),
        },
        {
          path: '/keyWords',
          name: 'keyWords',
          component: () => import("../views/MasterData/KeyWords.vue"),
        },
        {
          path: '/laydownMeasurement',
          name: 'laydownMeasurement',
          component: () => import("../views/MasterData/LaydownMeasureFile.vue"),
        },
        {
          path: '/laydownMeasurementDetail',
          name: 'laydownMeasurementDetail',
          component: () => import("../views/MasterData/LaydownMeasurementDetail.vue"),
        },
        {
          path: '/sizeFit',
          name: 'sizeFit',
          component: () => import("../views/MasterData/SizeFit.vue"),
        },
        {
          path: '/labelManagement',
          name: 'labelManagement',
          component: () => import("../views/localImage/labelManagement.vue"),
        },
        {
          path: '/sizeAndFit',
          name: 'sizeAndFit',
          component: () => import("../views/MasterData/sizeAndFit.vue"),
        },
        {
          path: '/storeManage',
          name: 'storeManage',
          component: () => import("../views/MasterData/storeManage.vue"),
        },
        {
          path: '/hwTable',
          name: 'hwTable',
          component: () => import("../views/MasterData/hwTable.vue"),
        },
        //Fast Asset
        {
          path: '/fastDataImport',
          name: 'fastDataImport',
          component: () => import("../views/fastAsset/fastDataImport.vue"),
        },
        {
          path: '/fastAssetReview',
          name: 'fastAssetReview',
          component: () => import("../views/fastAsset/fastAssetReview.vue"),
        },
        {
          path: '/fastImageCompare',
          name: 'fastImageCompare',
          component: () => import("../views/fastAsset/fastImageCompare.vue"),
        },
        {
          path: '/fastImageQc',
          name: 'fastImageQc',
          component: () => import("../views/fastAsset/fastImageQc.vue"),
        },
        {
          path: '/fastImageTaskDetail',
          name: 'fastImageTaskDetail',
          component: () => import("../views/fastAsset/fastImageTaskDetail.vue"),
        },
        {
          path: '/fastDistribute',
          name: 'fastOrderManagement',
          component: () => import("../views/fastAsset/fastOrderManagement.vue"),
        },
        {
          path: '/fastTaskList',
          name: 'fastTaskList',
          component: () => import("../views/fastAsset/fastTaskList.vue"),
        },
        {
          path: '/fastImageCompareOperation',
          name: 'fastImageOperation',
          component: () => import('../views/fastAsset/fastImageCompareOperation.vue')
        },
        {
          path: '/fastImageQcOperation',
          name: 'fastImageQcOperation',
          component: () => import("../views/fastAsset/fastImageQcOperation.vue"),
        },
        //AGC
        {
          path: '/AgcDataImport',
          name: 'AgcDataImport',
          component: () => import("../views/AGC/AgcDataImport.vue"),
        },
        {
          path: '/AgcAssetReview',
          name: 'AgcAssetReview',
          component: () => import("../views/AGC/AgcAssetReview.vue"),
        },
        {
          path: '/AgcImageCompare',
          name: 'AgcImageCompare',
          component: () => import("../views/AGC/AgcImageCompare.vue"),
        },

        {
          path: '/AgcImageQc',
          name: 'AgcImageQc',
          component: () => import("../views/AGC/AgcImageQc.vue"),
        },
        {
          path: '/AgcImageQcOperation',
          name: 'AgcImageQcOperation',
          component: () => import("../views/AGC/AgcQcOperation.vue"),
        },
        {
          path: '/AgcImageTaskDetail',
          name: 'AgcImageTaskDetail',
          component: () => import("../views/AGC/AgcImageTaskDetail.vue"),
        },
        {
          path: '/AgcOrderManage',
          name: 'AgcOrderManage',
          component: () => import("../views/AGC/AgcOrderManagement.vue"),
        },
        {
          path: '/AgcTaskList',
          name: 'AgcTaskList',
          component: () => import("../views/AGC/AgcTaskList.vue"),
        },
        {
          path: '/AgcImageCompareOperation',
          name: 'AgcImageCompareOperation',
          component: () => import('../views/AGC/AgcImageCompareOperation.vue')
        },
        //colorDescription
        {
          path: '/colorDescription',
          name: 'colorDescription',
          component: () => import('../views/MasterData/colorDescription.vue')
        },
        //colorDescription
        {
          path: '/launchCalendarCopy',
          name: 'launchCalendarCopy',
          component: () => import('../views/Copy/launchCalendarCopy.vue')
        },
        //EPD
        {
          path: '/epdpCopyReview',
          name: 'epdpCopyReview',
          component: () => import('../views/EPD Copy/copyReview.vue')
        },
        {
          path: '/epdpCopyReviewOp',
          name: 'epdpCopyReview',
          component: () => import("../views/EPD Copy/CopyReviewOp.vue")
        },
        {
          path: '/epdpCopyReviewDetail',
          name: 'epdpCopyReview',
          component: () => import("../views/EPD Copy/CopyReviewDetail.vue")
        },
        {
          path: '/epdpCopyQuery',
          name: 'epdpCopyQuery',
          component: () => import('../views/EPD Copy/epdCopy.vue')
        },
        {
          path: '/epdpCopyOriginalDetail',
          name: 'epdpCopyOriginalDetail',
          component: () => import("../views/EPD Copy/epdpCopyOriginalDetail.vue"),
        },
        {
          path: '/epdpCopyQueryDetail',
          name: 'epdpCopyQuery',
          component: () => import("../views/EPD Copy/epdpCopyQueryDetail.vue"),
        },
      ]
    },
    {
      path: '/ExportPDF',
      name: 'ExportPDF',
      component: () => import("../views/Sys/ExportPDF.vue"),
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js